import { render } from "./AddSubPlan.vue?vue&type=template&id=35aae13d&scoped=true"
import script from "./AddSubPlan.vue?vue&type=script&lang=js"
export * from "./AddSubPlan.vue?vue&type=script&lang=js"

import "./AddSubPlan.vue?vue&type=style&index=0&id=35aae13d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35aae13d"]])

export default __exports__